import React from 'react'
import { Modal, Button } from 'react-bootstrap';
import ContactAgentContainer from './ContactAgentContainer';
import ContactAgentContainerProperty from './ContactAgentContainerProperty';

export default function ContactModal(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Contact Us
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ContactAgentContainerProperty property={props.property} />
            </Modal.Body>
            {/* <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer> */}
        </Modal>
    )
}
